import { css } from 'emotion';

import { colors, fonts } from '../styles';

export const icon = css`
  flex-shrink: 0;
  margin-right: 10px;
`;

export const overlay = css`
  min-width: 320px;
  z-index: 1300;

  && {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    box-sizing: border-box;
    margin: 5px 0;
    border: 1px solid ${colors.gray.light};
    max-height: 45vh;
    overflow-y: auto;
  }
`;

export const searchBox = css`
  margin: 10px 10px 0;
`;

export const itemsList = css`
  margin-top: 6px;
  margin-bottom: 10px;
`;

export const item = css`
  && {
    display: flex;
    justify-content: space-between;
    margin: 0;
    padding: 10px 20px;
    box-sizing: content-box;
    min-height: unset;

    & span {
      display: flex;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &.selected {
      & span {
        font-weight: ${fonts.weight.medium};
      }
    }

    &.selectNone {
      & span {
        font-weight: ${fonts.weight.light};
      }
    }

    &.disabled {
      & span {
        color: ${colors.gray.light};
        cursor: not-allowed;
      }
    }
  }
`;

export const noResults = css`
  && {
    display: flex;
    width: auto;
    padding: 0 10px;
    margin: 6px 0;
    justify-content: center;
    font-size: ${fonts.size.small};
    font-weight: ${fonts.weight.light};
    line-height: 19px;
    color: ${colors.gray.dark};
  }
`;

export const checkIcon = css`
  color: ${colors.success.default};
`;

export const button = css`
  max-width: 250px;

  && {
    display: flex;
    align-items: center;
  }
`;

export const ellipse = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const loading = css`
  height: 17px;
`;
